import React, {FC} from "react"
import styled from "styled-components"

import Badge from "@irati/ui/src/Badge"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"

interface Props {
  isVerified?: boolean
}

const StyledBadge = styled(Badge)`
  position: relative;
  top: 20px;
  left: 110px;
  padding: 0 ${({theme}) => theme.spacing.half};
`

export const StyledIcon = styled(Icon)<Props>`
  path:last-child {
    fill: ${({bgColor}) => bgColor};
  }
`

export const IconWrapper = styled(Flex)`
  width: 12px;
  height: 12px;
  background: ${({theme, color}) => color || theme.colors.greys.black};
  border-radius: 100%;
`

const VerifyBadge: FC<Props> = ({isVerified = false}) => {
  const theme = useTheme()
  const text = isVerified ? "Verified" : "Unverified"
  const bgColor = isVerified ? theme.colors.utility.bgSuccess : theme.colors.utility.bgWarning
  const icon = isVerified ? IconTypes.tick : IconTypes.circleAlertFill
  const iconColor = isVerified ? theme.colors.utility.success : theme.colors.utility.warning

  return (
    <Flex>
      <StyledBadge bgColor={bgColor} color={theme.colors.greys.black}>
        <Flex gap={0.5} alignItems="center">
          <IconWrapper color={iconColor} justifyContent="center" alignItems="center">
            <StyledIcon icon={icon} color={iconColor} bgColor={theme.colors.greys.white} size={isVerified ? 6 : 12} />
          </IconWrapper>
          <Body weight="bold" small>
            <FormattedMessage id={text} />
          </Body>
        </Flex>
      </StyledBadge>
    </Flex>
  )
}

export default VerifyBadge
